<div [ngStyle]="wrapperStyle" class="headroom-wrapper {{ wrapperClassName }}" [style.height.px]="wrapperHeight">
    <div #ref
        [ngStyle]="innerStyle"
        [class]="innerClassName"
        [class.headroom]="true"
        [class.headroom--unpinned]="state === 'unpinned' && !disable"
        [class.headroom--pinned]="state === 'pinned' || disable">
        <ng-content></ng-content>
    </div>
</div>